import styled from 'styled-components';

const CreateAndEditPartnersContainer = styled.div`
  flex: 1;
  width: 100%;
`;

export { CreateAndEditPartnersContainer };
